export default __webpack_public_path__ + "static/media/logo.3dd845e8.svg";